<div class="zwi-body" [class]="{'zwi-body--bold': bold, 'zwi-text-center': center, 'zwi-body--offset': offset}">
  <ng-content></ng-content>
</div>
